export const HANDOFF_PANEL_PARAM = "circle_ai_panel";
export const HANDOFF_CONVERSATION_PARAM = "circle_ai_conversation";
